import React, { useEffect, useRef, useState } from "react";
import { BsThreeDotsVertical } from "react-icons/bs";
import asscentsLogo from "../../assets/asscentsLogo.png";
import "./topnav.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";
import StockReconciliationExportModal from "../modals/stockReconciliationExportModal";
import stockExport from "../../assets/stockExport.svg";
import ErrorPopup from "../Popups/ErrorPopup";
import SuccessPopup from "../Popups/SuccessPopUp";
import { motion } from "framer-motion";

const Topnav = ({ open, setOpen }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const componentRef = useRef(null);
  const [menuOptionOpen, setMenuOptionOpen] = useState(false);
  const [stockExportShow, setStockExportShow] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState("");

  console.log(location.pathname, "location");

  const logoutHandler = () => {
    dispatch(logout(logoutSuccess, logoutError));
  };

  const timeOutFnc = () => {
    setShowSuccessPopup(false);
    navigate("/login");
  };
  const logoutSuccess = (data) => {
    console.log(data);
    setShowSuccessPopup(true);
    const message = data.data.message;
    const msg_updated = message.charAt(0).toUpperCase() + message.slice(1);
    setShowSuccessMsg(msg_updated);
    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const logoutError = (err) => {
    console.log(err);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  const headingVariants = {
    visible: { opacity: 1, x: 0, transition: { duration: 0.5 } },
    hidden: { opacity: 0, x: -50 },
  };

  useEffect(() => {
    if (menuOptionOpen) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [menuOptionOpen]);

  const handleClickOutside = (event) => {
    if (componentRef.current && !componentRef.current.contains(event.target)) {
      setMenuOptionOpen(false);
    }
  };

  return (
    <>
      <div className="header d-flex justify-content-between">
        <motion.div
          variants={headingVariants}
          initial="hidden"
          animate="visible"
          className=" d-flex flex-row justify-content-between align-items-center   w-100 p-2"
        >
          <img
            src={asscentsLogo}
            alt="Asscents Logo"
            className="svgAsscents"
            onClick={() => {
              navigate("/current-orders");
            }}
          />
        </motion.div>
        <div className=" d-flex align-items-center justify-content-center p-3">
          <div className="d-none d-md-block">
            <div className="d-flex gap-2 me-3 position-relative ">
              {location.pathname === "/notification" ? (
                <button
                  className="nav_faq_btn py-2 px-4 fs_12 fw_500 "
                  onClick={() => {
                    navigate("/current-orders");
                  }}
                >
                  Home
                </button>
              ) : (
                <button
                  className="nav_faq_btn py-2 px-4 fs_12 fw_500 "
                  onClick={() => {
                    navigate("/notification");
                  }}
                >
                  Notifications
                </button>
              )}

              <motion.button
                whileHover={{ scale: 1.1 }}
                transition={{ type: "spring", stiffness: 400, damping: 5 }}
                className="header_button py-2 px-2 mx-2 fs_12 d-none d-xl-block text-nowrap"
                onClick={() => {
                  setStockExportShow(true);
                }}
              >
                Stock Reconsolation Report
              </motion.button>
              <button
                className="header_button py-2 px-2 mx-2 fs_12 d-xl-none"
                onClick={() => {
                  setStockExportShow(true);
                }}
              >
                <img src={stockExport} />
              </button>
              <button
                className="nav_faq_btn py-2 px-4 fs_12 fw_500 "
                onClick={() => {
                  navigate("/faq");
                }}
              >
                FAQ’s
              </button>
              <button
                className="nav_support_btn py-2 px-4 fs_12 fw_500 text-white"
                onClick={() => {
                  navigate("/support");
                }}
              >
                SUPPORT
              </button>
            </div>
          </div>
          <span className="mail-address fw_400 fs_14 d-none d-lg-block">
            {localStorage.getItem("email")}
          </span>
          <div ref={componentRef}>
            <button
              type="button"
              className="dots-button"
              onClick={() => {
                setMenuOptionOpen(!menuOptionOpen);
              }}
            >
              <BsThreeDotsVertical size={15} color="#262C3D" />
            </button>
            {menuOptionOpen ? (
              <div className="position-relative">
                <div className="menu_option_contianer  py-3 px-5">
                  <span
                    className=" fw_500 fs_14 text-left cursor_pointer"
                    onClick={() => logoutHandler()}
                  >
                    Logout
                  </span>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <StockReconciliationExportModal
        StockShow={stockExportShow}
        stockClose={() => setStockExportShow(false)}
      />
      <ErrorPopup
        show={showErrorPopup}
        title={showErrorMsg}
        handleClose={closeErrorPopup}
      />
      <SuccessPopup show={showSuccessPopup} title={showSuccessMsg} />
    </>
  );
};

export default Topnav;
